import classNames from "classnames"
import React from "react"

import { getTextAlignClass } from "../../../utils/text"

import { Color } from "@constants/V2/color"
import { getTextColorClass } from "@utils/V2/color"

type Props = {
  content: string
  textColor?: Color
  linkColor?: Color
  textAlign?: Storyblok.TextAlign
  coloredListMarkers?: boolean
  className?: string
}

const HtmlRichText = ({
  content,
  textColor = Color.Black,
  linkColor = Color.Blue,
  textAlign,
  coloredListMarkers = false,
  className,
}: Props) => {
  const linkTextColor = getTextColorClass(linkColor)
  return (
    <div
      className={classNames(
        "[&>br:first-child]:hidden [&_a]:underline [&_a]:decoration-current [&_li+li]:mt-8 [&_li]:ml-16 [&_li_p]:pb-0 [&_ol]:list-[inherit] [&_ol]:!p-0 [&_ol]:pb-24 [&_p]:!mb-0 [&_p]:pb-24 [&_ul]:list-[inherit] [&_ul]:!p-0 [&_ul]:pb-24",
        coloredListMarkers &&
          "[&_ul_li::marker]:text-blue [&_ul_li::marker]:content-['✓_']",
        getTextColorClass(textColor),
        getTextAlignClass(textAlign),
        `[&_a]:!${linkTextColor}`,
        className
      )}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  )
}

export default HtmlRichText
